import { IVisualProps } from 'builder/components/CIO-Dasboard-2.0/types'
import ExpertTag from '../../Tags/ExpertTag'
import * as Styled from './styles'

export const CareerAdviseVisual = ({ imgUrl, alt }: IVisualProps) => {
  return (
    <Styled.VisualContainer>
      <ExpertTag />
      <Styled.VisualImageContainer>
        <Styled.VisualImage src={imgUrl} alt={alt} />
      </Styled.VisualImageContainer>
    </Styled.VisualContainer>
  )
}
